import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import FlashMessageBanner from "./flash-message-banner"
import { breakpointTablet } from "../settings"

const TopNavigation = ({ children }) => (
  <div style={styles.wrapper}>
    <div style={[styles.base, { background: "#383838" }]}>{children}</div>
    <div style={styles.flashWrapper}>
      <FlashMessageBanner />
    </div>
  </div>
)

const styles = {
  wrapper: {
    height: "4.5rem",
    [breakpointTablet]: {
      width: "100%"
    }
  },
  base: {
    display: "flex",
    height: "100%",
    justifyContent: "space-between"
  },
  flashWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: "-1"
  }
}

TopNavigation.propTypes = {
  children: PropTypes.node
}

export default Radium(TopNavigation)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/top-navigation.jsx